export default {
  methods: {
    arrayContainsAllFromArray(arr1, arr2) {
      return arr1.every((i1) => arr2.map((i2) => i2.toLowerCase()).includes(i1.toLowerCase()));
    },

    arrayContainsAnyFromArray(arr1, arr2) {
      return arr1.some((i1) => arr2.map((i2) => i2.toLowerCase()).includes(i1.toLowerCase()));
    },

    iterableContainsString(iterable = null, str = '', caseSensitive = false) {
      if (!iterable) return false;
      if (caseSensitive) return iterable.includes(str);
      if (typeof iterable === 'string') {
        return iterable.toLowerCase().includes(str.toLowerCase());
      }
      return iterable.some((i) => i.toLowerCase().includes(str.toLowerCase()));
    },
  },
};
